import React, { useState } from 'react';
import './Navigation.css';
import { Link } from 'react-router-dom';

const Navigation = () => {
    const [active, setActive] = useState(false);

    return (
        <main className="main">
            <header className="header">
                <div className="wrap d-flex">
                    <Link to='/'>
                        <p className="logo" typeof='text'>BHUIYAN  </p>
                    </Link>
                    <nav className="menu ">
                        <ul>
                            <li><Link to="/home">Home</Link></li>
                            <li><Link to="/about">About</Link></li>
                            <li><Link to="/work">Works</Link></li>
                            <li><Link to="/blog">Blogs</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                            <li><a href="https://drive.google.com/uc?export=download&amp;id=1R98QtDc2Ugrpi1adkBoSc13PGRqNccO1" className="btn btn-outline-info">Download Resume&nbsp;<i class="fa fa-arrow-down"></i></a></li>
                        </ul>
                    </nav>
                </div>
                <div className="fixed-top">
                    <a className={!active && "sidemenu-toggler"} onClick={() => setActive(true)} >
                        <span></span>
                        <span></span>
                        <span></span>
                    </a>
                </div>
                <div className={active ? "sidemenu active" : "sidemenu"}>
                    <a className="close" onClick={() => setActive(false)} ></a>
                    <nav>
                        <ul>
                            <li><Link to="/home">Home</Link></li>
                            <li><Link to="/about">About</Link></li>
                            <li><Link to="/work">Works</Link></li>
                            <li><Link to="/blog">Blog</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                            <li><a href="https://drive.google.com/uc?export=download&amp;id=1R98QtDc2Ugrpi1adkBoSc13PGRqNccO1" className="btn btn-danger">Download Resume&nbsp;<i class="fa fa-arrow-down"></i></a></li>
                        </ul>
                    </nav>
                    <footer>
                        <div className="social">
                            <a href='https://www.facebook.com/shahin19sep/' target='_blank'><i className="fa fa-facebook"></i></a>
                            <a href='https://twitter.com/ShahinurAlamBh1' target="_blank"><i className="fa fa-twitter"></i></a>
                            <a href='https://www.linkedin.com/in/shahinur-alam-bhuiyan-178161211/' target='_blank'><i className="fa fa-linkedin"></i></a>
                            <a href='https://github.com/ShahinurAlamBhuiyan' target='_blank'><i className="fa fa-github"></i></a>
                        </div>
                        <p>Designed & Built by Shahinur Alam Bhuiyan</p>
                    </footer>
                </div>
            </header>
        </main>
    );
};

export default Navigation;